import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs, FilterSettingsModel, SearchSettingsModel, TextWrapSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { ColumnChangeBO, EDI271BO,  } from '../../eligibility270/eligibility270.model';
import { columnWidth } from '../../icd10/icd10.model';
import {  GetEDI271ClientBO } from '../client-parent.model';
import { EligibilityReportService } from './eligibility-report.service';
import { CommonApiService } from 'src/app/commonapiservice';

@Component({
  selector: 'app-eligibility-report',
  templateUrl: './eligibility-report.component.html',
  styleUrls: ['./eligibility-report.component.scss']
})
export class EligibilityReportComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: string = '00000000-0000-0000-0000-000000000000';
  arraycol: any = [];
  EDI271Client: GetEDI271ClientBO = new GetEDI271ClientBO();
  public toolbar: ToolbarItems[];
  public searchSettings: SearchSettingsModel;
  public wrapSettings: TextWrapSettingsModel;
  @ViewChild('grid') public grid: GridComponent;
  temphide: any = [];
  filterOptions: FilterSettingsModel;
  initialPage: object;
  height: string = "200px";
  datalength: number = 0
  getClientListerr: any = ""
  isDatashowfilter: boolean = false;
  public formatOptions: object;
  eligiblitydropdata: any = ["true", "false"];
  ISViewDetails: boolean = false;
  EligibleId: string = '00000000-0000-0000-0000-000000000000';
  viewFiles271: boolean = false;
  edi271list: EDI271BO[] = [];;
  @Input() DataFromList: GetEDI271ClientBO = new GetEDI271ClientBO();
  @Output() Event = new EventEmitter<GetEDI271ClientBO>();
  constructor(public datepipe: DatePipe, public global: GlobalComponent, 
    public general: GeneralService,  public eligibilityservice: EligibilityReportService, public router: Router, public toastrService: ToastrService, private ref: ChangeDetectorRef,
    public CommonAPI: CommonApiService,) {
    this.data = eligibilityservice;
  }
    //...........................................ngOnChanges................................................................
  ngOnChanges() {
  }
  ngOnInit(): void {
    this.toolbar = ['ColumnChooser'];
    this.initialPage = { currentPage: 1, pageSizes: ['10', '15', '20', '50', '100', '250'], pageSize: 10 }
    this.wrapSettings = { wrapMode: 'Content' };
    this.DataFromList.pageitem = 10;
    this.filterOptions = { type: 'Menu' };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.getEligiblityDetails();
  }
    //...........................................Refresh................................................................
  Refresh() {
    this.DataFromList = new GetEDI271ClientBO();
    this.getEligiblityDetails();
    this.grid.pageSettings.currentPage = 1;
  }
    //...........................................getEligiblityDetails................................................................
  getEligiblityDetails() {
    this.DataFromList.locationId = (this.global.globalLocationId ?? '00000000-0000-0000-0000-000000000000');
    this.eligibilityservice.ouputValues(this.DataFromList);
    let val = 0
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if ((data != null && data.result.length > 0)) {
        this.isDatashowfilter = true;
      }
      else {
        this.isDatashowfilter = false;
      }
      val++;
      if (data != null && data != undefined && val == 1) {
        
        if (data.result.length > 15) {
          this.grid.height = '500';
        }
        else {

          this.grid.height = 'auto';
        }
      }
    })

  }
  //...........................................dataStateChange................................................................
  public dataStateChange(state): void {
    let val = (state.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.DataFromList.orderColumn = state.sorted[0].name;
        this.DataFromList.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && state.action.action != "clearFilter") {
      
      if (this.DataFromList.type == "number") {


        this.DataFromList.value = state.action.currentFilterObject.value.toString();
        this.DataFromList.field = state.action.currentFilterObject.field;


      }
      else if (this.DataFromList.type == "date") {
        this.DataFromList.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.DataFromList.field = state.action.currentFilterObject.field;
      }
      else {
        this.DataFromList.value = state.action.currentFilterObject.value;
        this.DataFromList.field = state.action.currentFilterObject.field;





        this.DataFromList.matchCase = state.action.currentFilterObject.matchCase;
        this.DataFromList.operator = state.action.currentFilterObject.operator;

      }
    }
    else {
      if (val == "filtering" && state.action.action == "clearFilter") {
        this.DataFromList.field = "ClientName";
        this.DataFromList.matchCase = false;
        this.DataFromList.operator = "contains";
        this.DataFromList.value = "";
        this.DataFromList.type = "string"
        // this.EDI271Client.statusLid = this.ClientStatus[0].Key
      }
    }
    if (val == "paging" && state.action.name == "actionBegin") {
      // if (this.grid.pagerModule.pagerObj.pageSize != this.arraycol[0].Client.Pagesize) {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].EDI271Client.Pagesize != state.take) {
          this.arraycol[0].EDI271Client.Pagesize = state.take
         
          // }

        }

      }

    }
    this.getEligiblityDetails();
  }
  //...........................................onActionComplete................................................................
  public onActionComplete(args) {
    this.DataFromList.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.DataFromList.pageitem = this.grid.pagerModule.pagerObj.pageSize;


    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.DataFromList.type = args.columnType

    }


  }
   //...........................................show................................................................
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50); // give X and Y axis
  }
    //...........................................validatebutton................................................................
  validatebutton(args) {
    if (args.column.field == "checkeligibility") {

    

    }

  }
  
    
    //...........................................onResize................................................................
  onResize(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.grid.getColumnByField(args.column.field)
    column.width = args.column.width;
    this.ColumnArray.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }

    });
    
    }
  }
  //...........................................viewlasteb................................................................
  viewlasteb(id) {
    this.EligibleId = id;
    this.ISViewDetails = true;
    document.getElementById('openModal7').click();
  }
  //...........................................closeViewdetails................................................................
  closeViewdetails() {
    this.ISViewDetails = false;
    document.getElementById('openModal7').click();
  }
  //...........................................print................................................................
  print() {
    let url = "api/ClaimProcess/GetEligibilitySummaryListToPrint";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.DataFromList,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      let Printdata = data;
      document.getElementById('printalertOpen').click();
      var a = window.open('', '', 'height=700, width=700');
      a.document.write('<html>')
      a.document.write('<head><meta name="viewport" content="width=device-width, initial-scale=1"> <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></head>');
      a.document.write('<body ><table class="table table-hover table-bordered table-responsive" style="margin-top: 5px;margin-left: 10px;border:solid #000 !important; border-width:1px 0 0 1px !important;">');
      a.document.write('<thead>');
      a.document.write('<th style="border:solid #000 !important;border-width:0 1px 1px 0 !important;border-top:1px">Name</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">DOB</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Medicaid</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">MA Eligible</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Plans End Date</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Benefit End Date</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Last Eligibility Check</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">PMAP</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Program</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Waiver</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">SpendDown</th>');
      a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">MSHO</th>');
      a.document.write('</thead>');
      a.document.write('<tbody>');
      let count=0;
      Printdata.forEach(element => {
        count++;
        a.document.write('<tr style="border:solid #000 !important; border-width:1px 0 0 1px !important;">');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.clientName + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' +this.datepipe.transform(element.dob, "MM/dd/yyyy") + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.medicaid + '</td>');
        if (element.isMAEligible) {
          a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"><i class="fa fa-check-circle" ></i></td>');
        }
        else if (element.isMAEligible == false) {
          a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"><i class="fa fa-times-circle-o"></i></td>');
        }
        else if (element.isMAEligible == null) {
          a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"></td>');
        }
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + ((element.planEnd!=null&&element.planEnd!=undefined&&element.planEnd!='')?this.datepipe.transform(element.planEnd, "MM/dd/yyyy"):'') + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + ((element.benefitEnd!=null&&element.benefitEnd!=undefined&&element.benefitEnd!='')?this.datepipe.transform(element.benefitEnd, "MM/dd/yyyy"):'') + '</td>');

        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.lastEligibilityCheck == null ? "" : this.datepipe.transform(element.lastEligibilityCheck, "MM/dd/yyyy")) + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.pmap == null ? "" : element.pmap) + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.program == null ? "" : element.program) + '</td>');
        a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.waiver == null ? "" : element.waiver) + '</td>');
        if (element.spendDown) {
          a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"><i class="fa fa-check-circle" ></i></td>');
        }
        else if (element.spendDown == false) {
          a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"><i class="fa fa-times-circle-o"></i></td>');
        }
        else if (element.spendDown == null) {
          a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"></td>');
        }
        if (element.msho) {
          a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"><i class="fa fa-check-circle" ></i></td>');
        }
        else if (element.msho == false) {
          a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"><i class="fa fa-times-circle-o"></i></td>');
        }
        else if (element.msho == null) {
          a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"></i></td>');
        }
        a.document.write('</tr>');
      });
      a.document.write(' </tbody>  </table>');
      a.document.write('</body></html>');
      a.document.close();
      let interval=setInterval(()=>{
        if(count==Printdata.length)
        {
          setTimeout(() => {
            a.print()
          }, 1000);
          clearInterval(interval);
        }
      },100)
    },
      (err: any) => {
        this.toastrService.error(err, 'error')
      });
  }
    //...........................................closeprint................................................................
  closeprint() {
    console.log("close")
    document.getElementById('printalertOpen').click();
  }
    //...........................................showColumn................................................................
  showColumn() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
}
  //...........................................printDifferenceReport................................................................
  printDifferenceReport() {
    let trueIcon = `<i class="fa fa-check-circle"></i>`, falseIcon = `<i class="fa fa-times-circle-o"></i>`,
      nullIcon = ``;
      let url = "api/ClaimProcess/getEligibilityDifferenceList";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.DataFromList,url).pipe(takeUntil(this.onDestroy$)).subscribe((printdata: any) => {
      document.getElementById("differenceReportPrintAlertSpan").click();
      var a = window.open('', '', 'height=700, width=700');
      a.document.write(`
      <html>
      <head>
      <meta name="viewport" content="width=device-width, initial-scale=1"> <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
      <style>
      table, th, td {
        border: 1px solid black;
        border-collapse: collapse;
      }
      </style>
      </head>
      <body>
      <table class="table table-hover table-bordered table-responsive">
      <thead>
        <th >Name</th>
        <th >Eligibility Check</th>
        <th >Plans End Date</th>
        <th >Benefit End Date</th>
        <th >MA Eligible</th>
        <th >PMAP</th>
        <th >Program</th>
        <th >Waiver</th>
        <th >SpendDown</th>
        <th >MSHO</th>
      </thead>
      <tbody>
      `);
      let count=0;
      printdata.forEach(eligibilityClient => {
        a.document.write(`
        <tr>
        <td rowspan=`+ (eligibilityClient.eligibilitySummaryList.length + 1).toString() + `>` + eligibilityClient.clientName + `</td>
        </tr>
        `);
        eligibilityClient.eligibilitySummaryList.forEach(eligibilitySummary => {
          a.document.write(`
          <tr>
          <td>`+ this.datepipe.transform(eligibilitySummary.eligibilityCheckDate, "MM/dd/yyyy") + `</td>` + `
          <td>`+ this.datepipe.transform(eligibilitySummary?.planEnd, "MM/dd/yyyy") + `</td>` + `
          <td>`+ this.datepipe.transform(eligibilitySummary?.benefitEnd, "MM/dd/yyyy") + `</td>` + `
          <td style="text-align: center;">`+ (eligibilitySummary.isMAEligible == true ? trueIcon : eligibilitySummary.isMAEligible == false ? falseIcon : nullIcon) + `</td>` + `
          <td>`+ (eligibilitySummary.pmap ?? "") + `</td>` + `
          <td>`+ (eligibilitySummary.program ?? "") + `</td>` + `
          <td>`+ (eligibilitySummary.waiver ?? "") + `</td>` + `
          <td style="text-align: center;">`+ (eligibilitySummary.spendDown == true ? trueIcon : eligibilitySummary.spendDown == false ? falseIcon : nullIcon) + `</td>` + `
          <td style="text-align: center;">`+ (eligibilitySummary.msho == true ? trueIcon : eligibilitySummary.msho == false ? falseIcon : nullIcon) + `</td>` + `
          </tr>
          `)
        });
      });

      a.document.write(`
      </tbody> 
      </table>
      </body>
      </html>
      `);
      a.document.close();
      let interval=setInterval(()=>{
        if(count==printdata.length)
        {
         
         
          setTimeout(() => {
            a.print()
          }, 1000);
          clearInterval(interval);
        }
      },100)
    })
  }
    //...........................................closeDifferenceReportPrintAlert................................................................
  closeDifferenceReportPrintAlert() {
    document.getElementById('differenceReportPrintAlertSpan').click();
  }
   //......................................exportEligibilitysWithPaginationCsv.....................................................
   exportEligibilitysWithPaginationCsv() {
    this.DataFromList.pageitem = this.grid.pageSettings.pageSize;
    this.DataFromList.currentpageno = this.grid.pageSettings.currentPage;
    let url = "api/ClaimProcess/GetEligibilitySummaryListCurrentPageCSV";
    this.CommonAPI.saveorUpdateFunctionFileSaver(this.DataFromList,url,"EligibilityReport.csv");
  }
  //...........................................exportEligibiltyCsv................................................................
  exportEligibiltyCsv() {

    let url = "api/ClaimProcess/GetEligibilitySummaryListAllPageCSV";
      this.CommonAPI.saveorUpdateFunctionFileSaver(this.DataFromList,url,"EligibilityReport.csv"); 

  }

    //...........................................closecsvmodal................................................................
  closecsvmodal(){
    document.getElementById('exportascsv').click();
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

